<div class="main">
    <div class="narration">
        <h2>You see a bright white light which then morphes into a tunnel....</h2>
        <h3>What happened? Where am I? Did I die? </h3>
        <h2>Before you comphrend anything you reach your destination. You are standing behind a door. You pull but it doesn't open. It has an advanced locking system</h2>
        <div routerLink = "/escaperoom" class = "custbutton">Next</div>
    </div>

</div>